import { z } from "zod";
import { SORT_KEYS } from "./sort.js";

export const enrichmentSearchSchema = z.object({
  sort: z.enum(SORT_KEYS).default("default"),
  page: z.coerce.number().int().min(1).default(1),
});

export type EnrichmentSearch = z.infer<typeof enrichmentSearchSchema>;

export type SetEnrichmentSearch = (next: Partial<EnrichmentSearch>) => void;
